(function () {
  'use strict';
  if (window.OxxFinderCommerce) return;
  /* Size finder result rows (WP2 2026-10-03, ic-* catalogue table).
     One row per grade: material chip + hardness, smallest pack price (+ per piece), router label, one action.
     The route comes only from the oxx-finder-product-data section (oxx-route-consumer-guard-v1):
     non-DIRECT_BUY rows show no price and no cart; they get a "Request quote" link instead.
     Exported helpers pieces/validQuantity/rules keep their old signatures. */
  const cache = new Map(), cacheLife = 60000;
  const localeRoot = () => window.Shopify?.routes?.root || '/';
  const route = path => localeRoot() + path.replace(/^\//, '');
  const node = (tag, text, className) => {
    const n = document.createElement(tag);
    if (text != null) n.textContent = text;
    if (className) n.className = className;
    return n;
  };
  const pieces = title => {
    const m = String(title || '').trim().match(/^(\d[\d,]*)\s*(?:pcs?|pieces?)$/i);
    const n = m ? Number(m[1].replaceAll(',', '')) : null;
    return Number.isSafeInteger(n) && n > 0 ? n : null;
  };
  const rules = variant => ({ min: Number(variant.rules?.min) || 1, step: Number(variant.rules?.step) || 1, max: variant.rules?.max == null ? null : Number(variant.rules.max) });
  const validQuantity = (value, variant) => {
    const n = Number(value), r = rules(variant);
    return Number.isSafeInteger(n) && n >= r.min && (n - r.min) % r.step === 0 && (r.max == null || n <= r.max);
  };
  // Prices: always exactly 2 decimals. Per-piece reference: 3 decimals below 10 cents, "< $0.01" below one cent.
  const money = (cents, currency, digits) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency, minimumFractionDigits: digits || 2, maximumFractionDigits: digits || 2
  }).format(cents / 100);
  const perPiece = (cents, count, currency) => {
    const v = cents / count;
    if (v < 1) return '< ' + money(1, currency);
    return money(v, currency, v < 10 ? 3 : 2);
  };
  const MAT = { NBR: ['NBR', 'nbr', 'Nitrile'], FKM: ['FKM', 'fkm', 'Fluoroelastomer'], EPDM: ['EPDM', 'epdm', 'Ethylene propylene'], SILICONE: ['VMQ', 'vmq', 'Silicone'], FFKM: ['FFKM', 'ffkm', 'Perfluoroelastomer'] };
  const ROUTE = { DIRECT_BUY: 'Available to order', CHECK_AVAILABILITY: 'Confirm availability', QUOTE_REQUIRED: 'Quote required', CUSTOM: 'Custom order', ENGINEERING_REVIEW: 'Engineering review' };
  const mm = n => Number(n).toFixed(2), inch = n => (Number(n) / 25.4).toFixed(3);
  function productHref(row, variant) {
    const url = new URL(route('products/' + row.handle), location.origin);
    if (variant) url.searchParams.set('variant', variant.id);
    const context = new URLSearchParams(location.search).get('resolution_context_id');
    if (context) url.searchParams.set('resolution_context_id', context);
    return url.pathname + url.search;
  }
  function quoteHref(row, query, routeState) {
    const params = new URLSearchParams({ source: 'finder-result', product: row.handle, id: row.id, cs: row.cs, unit: 'mm', material: row.material, hardness: row.hardness });
    ['standard', 'standard_code', 'media', 'temperature', 'temperature_unit', 'pressure', 'pressure_unit', 'motion', 'application', 'context'].forEach(key => { if (query[key]) params.set(key, query[key]); });
    if (query.standard === 'ISO3601') params.set('standard_class', 'B');
    if (query.units === 'in') params.set('original_unit', 'in');
    params.set('size_or_sku', mm(row.id) + ' x ' + mm(row.cs) + ' mm');
    if (routeState) { params.set('route_state', routeState); params.set('request_mode', routeState); }
    return route('pages/bulk-quote') + '?' + params;
  }
  function reviewHref(row, query) {
    // The requirement stays the customer's. Candidate identity is kept separate.
    const url = new URL(window.OxxVnextFinder.quoteUrl(query), location.origin);
    url.pathname = route('pages/bulk-quote');
    url.searchParams.set('source', 'finder-same-size-review');
    url.searchParams.set('request_mode', 'NEED_HELP');
    url.searchParams.set('review_candidate', row.handle);
    url.searchParams.set('candidate_material', row.material);
    url.searchParams.set('candidate_hardness', row.hardness);
    return url.pathname + url.search;
  }
  // Smallest available pack with a price and a parseable piece count (same rule as snippets/oxx-ic-offer).
  function smallest(variants) {
    let best = null, bestN = 0;
    for (const v of variants || []) {
      if (!v || v.available !== true || !Number.isSafeInteger(v.price) || v.price <= 0) continue;
      const n = pieces(v.title);
      if (n && (!best || n < bestN)) { best = v; bestN = n; }
    }
    return best;
  }
  // At most three current-page requests run together. Nothing is fetched for other pages.
  function render({ output, rows, query, reviewOnly = false, showSize = false }) {
    const controllers = new Set(); let cancelled = false, cursor = 0, running = 0, sortKey = 'grade';
    const inIn = query.units === 'in';
    const bar = node('div', null, 'ic-fd-bar');
    bar.append(node('p', reviewOnly ? 'Same ID and CS in another material or hardness. Ask us to review before you order.' : 'Price shown for the smallest pack. Larger packs are on the product page.', 'ic-small ic-fd-bar__note'));
    let sortSeg = null;
    if (!reviewOnly && rows.length > 1) {
      sortSeg = node('div', null, 'ic-fd-sort'); sortSeg.setAttribute('role', 'group'); sortSeg.setAttribute('aria-label', 'Sort grades');
      sortSeg.append(node('span', 'Sort', 'ic-fd-sort__k'));
      [['grade', 'Grade'], ['price', 'Price / piece']].forEach(([key, label], i) => {
        const b = node('button', label); b.type = 'button'; b.dataset.sort = key; b.setAttribute('aria-pressed', String(i === 0));
        b.addEventListener('click', () => sortBy(key)); sortSeg.append(b);
      });
      bar.append(sortSeg);
    }
    const wrap = node('div', null, 'ic-table-wrap ic-fd-wrap');
    const table = node('table', null, 'ic-table ic-table--catalog ic-fd-table' + (showSize ? ' ic-fd-table--sizes' : ''));
    const caption = node('caption', reviewOnly ? 'Same size in other grades: review required' : 'Grades at this size with the smallest pack price', 'ic-sr');
    const cols = (showSize ? [['Size', 'size']] : []).concat([['Grade', 'grade'], ['Smallest pack', 'price'], ['Availability', 'avail'], ['Action', 'act']]);
    const head = node('thead'), headRow = node('tr'), body = node('tbody');
    cols.forEach(([label, key]) => {
      const th = node('th', null, 'ic-fd-th--' + key); th.scope = 'col';
      if (key === 'act') th.append(node('span', label, 'ic-sr')); else th.textContent = label;
      headRow.append(th);
    });
    head.append(headRow); table.append(caption, head, body); wrap.append(table);
    output.append(bar, wrap);
    const refs = rows.map((row, index) => {
      const tr = node('tr', null, 'ic-fd-row'); tr.dataset.handle = row.handle; tr.dataset.route = 'loading';
      const cells = {};
      cols.forEach(([label, key]) => { const td = node('td', null, 'ic-fd-row__' + key); td.dataset.label = label; cells[key] = td; tr.append(td); });
      const m = MAT[row.material] || [row.material, 'nbr', row.material];
      const gradeName = m[0] + ' ' + row.hardness + ' Shore A';
      if (showSize) {
        const a = node('a', null, 'ic-fd-size'); a.href = productHref(row);
        a.append(node('span', inIn ? inch(row.id) + ' × ' + inch(row.cs) : mm(row.id) + ' × ' + mm(row.cs), 'ic-num'), document.createTextNode(inIn ? ' in' : ' mm'));
        cells.size.append(a, node('small', inIn ? mm(row.id) + ' × ' + mm(row.cs) + ' mm' : inch(row.id) + ' × ' + inch(row.cs) + ' in', 'ic-num'));
      }
      const g = node('a', null, 'ic-fd-grade'); g.href = productHref(row);
      const t = node('span', null, 'ic-fd-grade__t');
      const hard = node('b'); hard.append(document.createTextNode(row.hardness), node('span', ' Shore A', 'ic-fd-sh-l'), node('span', 'A', 'ic-fd-sh-s'));
      t.append(hard, node('small', m[2]));
      if (reviewOnly) {
        if (query.material && row.material !== query.material) t.append(node('small', 'Different material', 'ic-fd-diff'));
        if (query.hardness && row.hardness !== String(query.hardness).replace(/A$/i, '')) t.append(node('small', 'Different hardness', 'ic-fd-diff'));
      }
      g.append(node('span', m[0], 'ic-mat-code ic-mat-code--' + m[1]), t); cells.grade.append(g);
      cells.price.append(node('span', null, 'ic-fd-skel'));
      cells.avail.append(node('span', 'Checking…', 'ic-fd-muted'));
      const act = node('a', 'Details', 'ic-btn ic-btn--sm ic-btn--ghost ic-fd-act'); act.href = productHref(row);
      act.setAttribute('aria-label', 'Details: ' + gradeName); cells.act.append(act);
      body.append(tr);
      return { row, tr, cells, act, gradeName, pp: Infinity, index };
    });
    const active = () => !cancelled && wrap.isConnected;
    function resort() {
      const list = [...refs].sort(sortKey === 'price' ? (a, b) => (a.pp - b.pp) || (a.index - b.index) : (a, b) => a.index - b.index);
      list.forEach(r => body.append(r.tr));
    }
    function sortBy(key) {
      sortKey = key;
      if (sortSeg) sortSeg.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.sort === key)));
      resort();
    }
    async function loadProduct(row) {
      const key = localeRoot() + row.handle, stored = cache.get(key);
      if (stored && Date.now() - stored.time < cacheLife) return stored.data;
      const controller = new AbortController(); controllers.add(controller);
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(route('products/' + row.handle), location.origin); url.searchParams.set('section_id', 'oxx-finder-product-data');
        let response;
        // The storefront can answer 429 under bursts; back off and retry twice before giving up on this row.
        for (let attempt = 0; attempt < 3; attempt++) {
          response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (response.status !== 429) break;
          await new Promise(resolve => setTimeout(resolve, 1200 * (attempt + 1)));
        }
        if (!response.ok) { const error = new Error('Product details are unavailable.'); error.status = response.status; throw error; }
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = html.querySelector('[data-oxx-finder-product]');
        if (!payload) throw new Error('Product details are unavailable.');
        const data = JSON.parse(payload.textContent);
        // Shopify missing-product section responses may be HTTP 200 with an explicit empty identity.
        if (data.handle === null && data.title === null && data.driftStatus === 'MISSING' && Array.isArray(data.variants) && data.variants.length === 0) {
          const error = new Error('Product is not currently listed.'); error.status = 404; throw error;
        }
        if (data.handle !== row.handle || !['DIRECT_BUY', 'CHECK_AVAILABILITY', 'QUOTE_REQUIRED', 'CUSTOM', 'ENGINEERING_REVIEW'].includes(data.routeState) || !['order', 'quote', 'details'].includes(data.mode) || !/^[A-Z]{3}$/.test(data.currency) || !Array.isArray(data.variants)) throw new Error('Product details are unavailable.');
        cache.delete(key); cache.set(key, { time: Date.now(), data });
        if (cache.size > 60) cache.delete(cache.keys().next().value);
        return data;
      } finally { clearTimeout(timer); controllers.delete(controller); }
    }
    function setAct(ref, label, href, dark) {
      ref.act.textContent = label; ref.act.href = href;
      ref.act.className = 'ic-btn ic-btn--sm ic-fd-act ' + (dark ? 'ic-btn--dark' : 'ic-btn--ghost');
      ref.act.setAttribute('aria-label', label + ': ' + ref.gradeName);
    }
    const pill = (state, label) => node('span', label, 'ic-route ic-route--' + state);
    function paint(ref, data) {
      if (!active()) return;
      const { row, tr, cells } = ref;
      cells.price.replaceChildren(); cells.avail.replaceChildren();
      if (reviewOnly) {
        tr.dataset.route = 'REVIEW';
        cells.price.append(node('span', 'After review', 'ic-fd-muted'));
        cells.avail.append(pill('ENGINEERING_REVIEW', 'Review first'));
        setAct(ref, 'Request review', reviewHref(row, query), false);
        return;
      }
      if (data.routeState !== 'DIRECT_BUY') {
        tr.dataset.route = data.routeState;
        cells.price.append(node('span', 'Quoted on request', 'ic-fd-muted'));
        cells.avail.append(pill(data.routeState, ROUTE[data.routeState] || 'Quote required'));
        setAct(ref, 'Request quote', quoteHref(row, query, data.routeState), false);
        return;
      }
      const offer = data.mode === 'order' ? smallest(data.variants) : null;
      if (!offer) {
        tr.dataset.route = 'DIRECT_NOPRICE';
        cells.price.append(node('span', 'See packs', 'ic-fd-muted'));
        cells.avail.append(pill('CHECK_AVAILABILITY', 'Confirm pack'));
        setAct(ref, 'Choose pack', productHref(row), true);
        return;
      }
      const n = pieces(offer.title);
      tr.dataset.route = 'DIRECT_BUY';
      ref.pp = offer.price / n;
      cells.price.append(node('strong', money(offer.price, data.currency), 'ic-num'), node('span', ' / ' + n.toLocaleString('en') + ' pcs', 'ic-fd-pack'), node('small', perPiece(offer.price, n, data.currency) + ' / piece', 'ic-num'));
      cells.avail.append(pill('DIRECT_BUY', 'Available to order'));
      setAct(ref, 'Choose pack', productHref(row, offer), true);
      if (sortKey === 'price') resort();
    }
    async function hydrate(ref) {
      try { const data = await loadProduct(ref.row); if (active()) paint(ref, data); }
      catch (error) {
        if (!active()) return;
        cache.delete(localeRoot() + ref.row.handle);
        ref.tr.dataset.route = 'ERROR';
        ref.cells.price.replaceChildren(node('span', 'Price unavailable', 'ic-fd-muted'));
        const missing = error.status === 404;
        ref.cells.avail.replaceChildren(node('span', missing ? 'Confirm availability' : 'See product page', 'ic-fd-muted'));
        if (missing) {
          ref.tr.dataset.route = 'CHECK_AVAILABILITY';
          ref.tr.querySelectorAll('a.ic-fd-grade, a.ic-fd-size').forEach(a => { a.href = reviewOnly ? reviewHref(ref.row, query) : quoteHref(ref.row, query, 'CHECK_AVAILABILITY'); });
        }
        if (reviewOnly) setAct(ref, 'Request review', reviewHref(ref.row, query), false);
        else if (missing) setAct(ref, 'Request quote', quoteHref(ref.row, query, 'CHECK_AVAILABILITY'), false);
        else setAct(ref, 'Details', productHref(ref.row), false);
      }
    }
    function pump() { while (active() && running < 3 && cursor < refs.length) { running++; hydrate(refs[cursor++]).finally(() => { running--; pump(); }); } }
    Promise.resolve().then(pump);
    return { cancel() { cancelled = true; wrap.inert = true; for (const c of controllers) c.abort(); controllers.clear(); } };
  }
  window.OxxFinderCommerce = { render, pieces, validQuantity, rules, money, perPiece };
})();
